import { atom } from 'recoil';

const sessionStorageEffect = (key) => ({ setSelf, onSet }) => {
  const saved = sessionStorage.getItem(key);
  if (saved) {
    try { setSelf(JSON.parse(saved)); } catch (e) { /* ignore */ }
  }
  onSet((newValue, _, isReset) => {
    isReset
      ? sessionStorage.removeItem(key)
      : sessionStorage.setItem(key, JSON.stringify(newValue));
  });
};

export const teacherInfoState = atom({
  key: 'teacherInfoState',
  default: {
    managerNumber: null,
    managerName: null,
    advisorNumber: null,
    advisorName: null,
    sisCourseId: [],
  },
  effects_UNSTABLE: [sessionStorageEffect('recoil_teacherInfo')],
});
